<template>
  <div class="order" :class="{ guest: !loggedIn }">
    <header v-if="loggedIn" class="mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600">
      <div class="mdl-layout__header-row">
        <span>Order</span>
        <div class="mdl-layout-spacer"></div>
      </div>
    </header>

    <div class="orderFormHolder" v-if="state == 'ready'">

      <div class="mdl-card mdl-shadow--2dp orderForm">
        <div class="mdl-card__title mdl-color--primary">
          <h2 class="mdl-card__title-text">{{ i18n().billingData }}</h2>
        </div>

        <div class="mdl-card__supporting-text mdl-card--expand loading">
          <div class="serverError" v-if="error">{{ user_i18n().errors[error] || error }}</div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label field">
            <input class="mdl-textfield__input" type="text" id="firstName" v-model="editedUserData.firstName"
                   v-bind:required="required" ref="firstName">
            <label class="mdl-textfield__label" for="firstName">{{ user_i18n().firstName }}</label>
          </div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label field">
            <input class="mdl-textfield__input" type="text" id="lastName" v-model="editedUserData.lastName"
                   v-bind:required="required" ref="lastName">
            <label class="mdl-textfield__label" for="lastName">{{ user_i18n().lastName }}</label>
          </div>

          <PhoneInput class="phoneNumber field"
                      :value.sync="editedUserData.phoneNumber" :required="required" :invalid="phoneNumberInvalid"
                      :label="user_i18n().phoneNumber"></PhoneInput>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label field">
            <input class="mdl-textfield__input" type="text" id="companyName" v-model="editedUserData.companyName"
                   v-bind:required="required" ref="companyName">
            <label class="mdl-textfield__label" for="companyName">{{ user_i18n().companyName }}</label>
          </div>

          <CountryInput class="country field"
                        :value.sync="editedUserData.country" :required="required" :invalid="countryInvalid"
                        :label="user_i18n().country"></CountryInput>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label field">
            <input class="mdl-textfield__input" type="text" id="city" v-model="editedUserData.city"
                   v-bind:required="required" ref="city">
            <label class="mdl-textfield__label" for="city">{{ user_i18n().city }}</label>
          </div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label field">
            <input class="mdl-textfield__input" type="text" id="addressLine1" v-model="editedUserData.addressLine1"
                   v-bind:required="required" ref="addressLine1">
            <label class="mdl-textfield__label" for="addressLine1">{{ user_i18n().addressLine1 }}</label>
          </div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label field">
            <input class="mdl-textfield__input" type="text" id="addressLine2" v-model="editedUserData.addressLine2"
                   ref="addressLine2">
            <label class="mdl-textfield__label" for="addressLine2">{{ user_i18n().addressLine2 }}</label>
          </div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label field">
            <input class="mdl-textfield__input" type="text" id="postalCode" v-model="editedUserData.postalCode"
                   ref="postalCode">
            <label class="mdl-textfield__label" for="postalCode">{{ user_i18n().postalCode }}</label>
          </div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label field">
            <input class="mdl-textfield__input" type="text" id="taxNumber" v-model="editedUserData.taxNumber"
                   ref="taxNumber">
            <label class="mdl-textfield__label" for="taxNumber">{{ user_i18n().taxNumber }}</label>
          </div>
        </div>
        <div class="mdl-card__title mdl-color--primary">
          <h2 class="mdl-card__title-text">{{ i18n().productData }}</h2>
        </div>
        <div class="mdl-card__supporting-text mdl-card--expand loading">
          <h4>
            Semgregate Gold  -  250 USD / month
          </h4>
        </div>
        <div class="mdl-card__actions mdl-card--border">
          <button @click="back" class="prevButton mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
            {{ i18n().back }}
          </button>
          <button @click="buy" class="nextButton mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
            {{ i18n().next }}
          </button>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
  import api from "api"
  import i18n from "i18n"
  import PhoneInput from "./utils/PhoneInput.vue"
  import CountryInput from "./utils/CountryInput.vue"

  export default {
    name: 'hello',
    components: { PhoneInput, CountryInput },
    data () {
      return {
        state: 'loading',
        editedUserData: {},
        required: true,
        phoneNumberInvalid: false,
        countryInvalid: false,
        error: null,
        allFields: [ 'firstName', 'lastName', 'phoneNumber', 'companyName', 'country', 'addressLine1', 'addressLine2',
          'postalCode', 'taxNumber' ],
        requiredFields: [ 'firstName', 'lastName', 'phoneNumber', 'companyName', 'country', 'city', 'addressLine1' ]
      }
    },
    reactive: {
      user: ['user', 'user']
    },
    computed: {
      loggedIn() {
        return api.session.loggedIn
      },
      userData() {
        if(!this.user) return null
        let data = JSON.parse(JSON.stringify(this.user.userData || {}))
        return data
      }
    },
    watch: {
      userData() {
        if(!this.userData) return;
        this.editedUserData = JSON.parse(JSON.stringify(this.userData))
        let fields = this.allFields
        for(let field of fields) {
          if(!this.editedUserData[field]) this.editedUserData[field] = ''
        }
        if(this.editedUserData['phoneNumber']!='' && this.editedUserData['country'] =='') {
          let prefix = this.editedUserData['phoneNumber'].split(' ')[0]
          let found = countries.filter(c=>c.dial_code == prefix)[0]
          this.editedUserData['country'] = found ? found.code : ""
        }
        for(let field of fields) {
          if(this.editedUserData[field]!='') {
            let el = this.$refs[field]
            if(el) el = el.parentElement
            if(el) el.setAttribute('class', el.getAttribute('class').replace('is-invalid','')+' is-dirty')
          }
        }
        this.state='ready'
      }
    },
    methods: {
      i18n() { return i18n().order },
      user_i18n() { return i18n().user.changeUserData },
      back() {
        this.$router.back()
      },
      buy() {
        let anyEmpty = false
        for(let field of this.requiredFields) if(this.editedUserData[field].trim()=='') {
          let el = this.$refs[field][0]
          if(el) el = el.parentElement
          if(el) el.setAttribute('class', el.getAttribute('class')+' is-invalid')
          console.log("EMPTY FIELD", field)
          anyEmpty = true
        }
        if(anyEmpty) {
          return
        }

        let phoneNumber = this.editedUserData.phoneNumber
        let sep = phoneNumber.indexOf(' ')
        console.log("PN",phoneNumber, sep)
        if( sep == -1
          || phoneNumber.slice(0, sep).trim().length == 0
          || phoneNumber.slice(sep+1).trim().length < 3
          || !phoneNumber.match(/^[0-9 #+-]+$/)) {
          console.log("PN INVALID",
            phoneNumber.slice(0, sep).trim().length == 0,
            phoneNumber.slice(sep+1).trim().length < 3,
            !phoneNumber.match(/^[0-9 #+-]+$/)
          )
          this.phoneNumberInvalid = false
          this.phoneNumberInvalid = true
          this.required = true
          return;
        }

        this.state = "working"
        let productId = "semgregate"
        let planId = "semgregate_gold"
        let price = { value: 1, currency: "USD" }
        let orderPromise = api.request(['subscription', 'createOrder'],
          productId, planId, price)
        let saveUserPromise = api.request(['foxyCart', 'saveUser'], this.editedUserData)
        Promise.all([orderPromise, saveUserPromise]).then(
          ([orderId , foxyUserId, checkoutLink]) => {
            console.log("ORDER ID:", orderId)
            console.log("Foxy USER ID", foxyUserId)

            let startCheckoutPromise = api.request(['foxyCart', 'startSubscribeCheckout'],
              orderId, planId, productId, price)
            startCheckoutPromise.then(checkoutLink => {
              if (window.history) {
                history.pushState({}, window.location.href);
              }
              window.location.href = checkoutLink;
            })
          }
        )
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .order {
    height: 100%;
  }
  .orderFormHolder {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: calc(60vh - 80px);
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .orderForm {
    width: 600px;
    max-width: 95%;
  }

  .field {
    max-width: 250px;
    margin-right: 1em;
  }

  .nextButton {
    float: right;
  }

  .mdl-card.order {
  }

</style>



// WEBPACK FOOTER //
// Order.vue?666aacc2